module.exports = __webpack_public_path__ + "img/disclaimer.c4edb5e4.jpg";